export default "__VITE_ASSET__qpqFnmn4__"